export default {
domainInvalid: {
  siteUnavailableTitle: "Site Unavailable",
  siteUnavailableDesc: "This site is currently unavailable.",
  contactAdmin: "Please contact the administrator.",
  serverErrorTitle: "Service Unavailable",
  serverErrorDesc: "Failed to reach the server, please try again later.",
  serverErrorTip: "It will reconnect automatically once the server is back.",
  notAuthorizedTitle: "Domain Not Authorized",
  notAuthorizedDesc: "The current domain is not authorized to access this service.",
  checking: "Checking...",
  retry: "Retry",
  reload: "Reload",
  reloading: "Reloading...",
  checkingDomain: "Checking domain...",
  authorizedRedirecting: "Domain authorized, redirecting...",
  stillNotAuthorized: "Domain is still not authorized",
  reconnecting: "Reconnecting..."
}
};
